import styled from '@emotion/styled';

export const FraudAndComliancesTabWrapper = styled('div', { label: 'FraudAndComliancesTabWrapper' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding: 24px;
`;
